export default __webpack_public_path__ + "static/media/error_.3289be11.svg";